export enum RESULT_TYPE {
  BRANDS = 'brands',
  CATEGORIES = 'categories',
  POPULAR = 'popularSearches',
  TRENDING = 'trending',
  BOUTIQUE = 'boutique',
  COLLECTION = 'collection',
}
